import { SkeletonBodyText, SkeletonDisplayText } from "@shopify/polaris";
import styles from "./CartDrawerAdmin.module.css";
const CartDrawerAdminSkeleton = () => {
    return (
        <div className={styles.cartFormPreviewWrapper}>
            <div
                className={styles.cartFormWrapper}
                style={{
                    minWidth: "calc(100% - 420px)",
                }}
            >
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <SkeletonDisplayText maxWidth={"100%"} />
                </div>
                <div
                    className={styles.cartFormPanels}
                    style={{
                        gridTemplateColumns: "30% calc(70% - 1rem)",
                    }}
                >
                    <div className={styles.tabsPanel} style={{ boxShadow: "none" }}>
                        <SkeletonDisplayText maxWidth={"100%"} />
                        <SkeletonDisplayText maxWidth={"100%"} />
                        <SkeletonDisplayText maxWidth={"100%"} />
                        <SkeletonDisplayText maxWidth={"100%"} />
                    </div>
                    <div className={styles.formPanel}>
                        <SkeletonDisplayText maxWidth={"100%"} />
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 20,
                            }}
                        >
                            <SkeletonBodyText />
                            <SkeletonBodyText />

                            <SkeletonBodyText />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ minWidth: 400, marginLeft: 20 }}>
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
                <SkeletonDisplayText maxWidth={"100%"} />
            </div>
        </div>
    );
};

export default CartDrawerAdminSkeleton;
